<template>
    <div>
        <confirmacao :block_menu="true" :id_medico_fixo="$store.state.user.id_pessoa" />
    </div>
</template>

<script>
import Confirmacao from '../callcenter/Confirmacao.vue';

export default {
    data() {
        return { 

        }
    },

    components: { 
        Confirmacao, 
    },

    mounted() { 

        if ( this.$route.meta.perfil == 14 ) { 

            this.$store.commit("setBreadcrumb", [
                { name: "Assistência", path: "/assistencia/atend" },
                { name: "Agendas", path: "/assistencia/agendas" }
            ]);

        } else {

            this.$store.commit("setBreadcrumb", [
                { name: "Consultório", path: "/consultorio" },
                { name: "Agendas", path: "/consultorio/agendas" }
            ]);

        }

    }

}
</script>
